import { defineMessages } from "react-intl";
export default defineMessages({
    tourDialogTitle: {
        id: "aiDiscoverability.dashboard.tourDialogTitle",
        defaultMessage: "Discover's Tour",
    },
});
